module.exports = __webpack_public_path__ + "img/guidebook3.b19801f2.png";